export const LOG_FETCH_PREFIX = "fetch "
export const REQUEST_ID_HEADER = "x-request-id"
export const CF_RAY_HEADER = "cf-ray"
export const CF_BOT_SCORE_HEADER = "cf-bot-score"
export const CF_VERIFIED_BOT_HEADER = "cf-verified-bot"
export const CF_IPCOUNTRY_HEADER = "cf-ipcountry"
export const CF_CONNECTING_IP_HEADER = "cf-connecting-ip"
// Do not lowercase Accept-Language as generateServerHeaders use it with capital letters.
// If lowercased, both value (the given option and the default from generateServerHeaders) will be kept as an array with the default locale first.
export const ACCEPT_LANGUAGE_HEADER = "Accept-Language"
